'use client'

import { Button, Dialog, Navigation } from '@vinted/web-ui'
import { X24 } from '@vinted/monochrome-icons'
import { noop } from 'lodash'

import { useTranslate } from '@marketplace-web/shared/i18n'

import { AddressFormType } from 'constants/address'
import { AddressScreenTrackingType } from 'constants/tracking/address'
import { AddressFieldConfiguration, AddressModel } from 'types/models/address'

import ShippingAddress from '../ShippingAddress'

type Props = {
  isOpen: boolean
  address: AddressModel | null | undefined
  translationPrefix: string
  transactionId: number | null | undefined
  addressFormType: AddressFormType
  fieldConfiguration: Array<AddressFieldConfiguration>
  isPending: boolean
  screenTrackingType?: AddressScreenTrackingType
  shippingOrderId?: number | null
  onSubmit: (address: AddressModel) => void
  onClose: () => void
}

const AddressModal = ({
  isOpen,
  address,
  translationPrefix,
  transactionId,
  addressFormType,
  fieldConfiguration,
  isPending,
  screenTrackingType,
  shippingOrderId,
  onSubmit,
  onClose = noop,
}: Props) => {
  const translate = useTranslate(translationPrefix)

  function renderNavigation() {
    return (
      <Navigation
        body={translate('title')}
        right={
          <Button
            inline
            iconName={X24}
            styling={Button.Styling.Flat}
            onClick={onClose}
            testId="address-modal-navigation-close-button"
          />
        }
      />
    )
  }

  if (!transactionId) return null

  return (
    <Dialog show={isOpen} testId="address-modal">
      {renderNavigation()}
      <ShippingAddress
        address={address}
        transactionId={transactionId}
        addressFormType={addressFormType}
        isPending={isPending}
        fieldConfiguration={fieldConfiguration}
        screenTrackingType={screenTrackingType}
        shippingOrderId={shippingOrderId}
        onSubmit={onSubmit}
        onCancel={onClose}
      />
    </Dialog>
  )
}

export default AddressModal
